import { useState } from "react";
import { Button, ButtonKind, MagicLink } from "../../../../core/ui";
import { CoastShowPayload } from "./CoastContent.types";
import ArrowIcon from "../../../../core/components/icons/ArrowIcon.component";

interface CoastContentShowBumperMusicProps {
  show: CoastShowPayload;
}

export const CoastContentShowBumperMusic = ({ show: { fields } }: CoastContentShowBumperMusicProps) => {
  const [seeMore, setSeeMore] = useState(false);
  const toggleSeeMore = () => {
    setSeeMore(!seeMore);
  };

  return fields.bumper_music?.value?.length ? (
    <section className="bumper-music">
      <h3>Bumper Music</h3>
      {!seeMore ? (
        <Button className="see-more" kind={ButtonKind.SECONDARY} size="small" click={toggleSeeMore}>
          See More
          <ArrowIcon direction="down" />
        </Button>
      ) : (
        <Button className="see-more" kind={ButtonKind.SECONDARY} size="small" click={toggleSeeMore}>
          Show Less
          <ArrowIcon direction="up" />
        </Button>
      )}
      {seeMore ? (
        <ul>
          {fields.bumper_music.value.map((track, idx) => (
            <li key={idx}>
              <div className="track-details">
                <MagicLink external={true} target="_blank" to={track.url}>
                  {track.title}
                </MagicLink>
                <br />
                <span>({track.artist})</span>
              </div>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  ) : null;
};
